export const PythonLogo = ({ height = 16, width = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1304_21727)">
      <path
        d="M7.86177 0.796992C7.27244 0.799706 6.70965 0.849523 6.21445 0.936373C4.75565 1.19181 4.49079 1.72647 4.49079 2.71248V4.01469H7.93811V4.44876H4.49079H3.19704C2.19515 4.44876 1.31787 5.04563 1.04346 6.18106C0.726945 7.48254 0.712905 8.29468 1.04346 9.65363C1.28851 10.6652 1.87372 11.3859 2.87561 11.3859H4.06087V9.82487C4.06087 8.69709 5.04536 7.7023 6.21445 7.7023H9.65775C10.6162 7.7023 11.3814 6.92009 11.3814 5.96602V2.71248C11.3814 1.7865 10.5933 1.09091 9.65775 0.936373C9.06555 0.838666 8.45109 0.794278 7.86177 0.796992ZM5.99748 1.84434C6.35357 1.84434 6.64436 2.13726 6.64436 2.49743C6.64436 2.85633 6.35357 3.14655 5.99748 3.14655C5.64012 3.14655 5.35061 2.85633 5.35061 2.49743C5.35061 2.13726 5.64012 1.84434 5.99748 1.84434Z"
        fill="url(#paint0_linear_1304_21727)"
      />
      <path
        d="M11.8108 4.44531V5.96257C11.8108 7.13888 10.8046 8.12894 9.6572 8.12894H6.2139C5.27072 8.12894 4.49023 8.92903 4.49023 9.86522V13.1188C4.49023 14.0447 5.30262 14.5894 6.2139 14.855C7.30512 15.1731 8.35155 15.2305 9.6572 14.855C10.5251 14.606 11.3809 14.1048 11.3809 13.1188V11.8166H7.93756V11.3825H11.3809H13.1045C14.1064 11.3825 14.4798 10.6898 14.8282 9.65018C15.1881 8.57988 15.1728 7.55061 14.8282 6.17761C14.5806 5.18905 14.1077 4.44531 13.1045 4.44531H11.8108ZM9.87416 12.6847C10.2315 12.6847 10.521 12.9749 10.521 13.3338C10.521 13.694 10.2315 13.9869 9.87416 13.9869C9.51808 13.9869 9.22729 13.694 9.22729 13.3338C9.22729 12.9749 9.51808 12.6847 9.87416 12.6847Z"
        fill="url(#paint1_linear_1304_21727)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1304_21727"
        x1="0.800781"
        y1="0.796875"
        x2="8.69039"
        y2="7.57995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A9FD4" />
        <stop offset="1" stopColor="#306998" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1304_21727"
        x1="9.79132"
        y1="13.2243"
        x2="6.97296"
        y2="9.23971"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD43B" />
        <stop offset="1" stopColor="#FFE873" />
      </linearGradient>
      <clipPath id="clip0_1304_21727">
        <rect
          width="14.4"
          height="14.4"
          fill="white"
          transform="translate(0.800781 0.796875)"
        />
      </clipPath>
    </defs>
  </svg>
);
